module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_costume-2d89a0d9592f28e18f01dee8891ce8b2.jpg";